import { render } from "./MediaGallery.vue?vue&type=template&id=49ad30b0&scoped=true"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"

import "./MediaGallery.vue?vue&type=style&index=0&id=49ad30b0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ad30b0"]])

export default __exports__